import React from 'react';
import '../../styles/MetaSistema.css';
import iniciativesData from '../../data/iniciativeTimeline.json'; // Asegúrate de la ruta correcta

const Iniciatives = () => {
    return (
        <section className="iniciatives-section">
            <div className='container'>
                {/* Título */}
                <div className="title-container" data-aos="fade-up" data-aos-offset="50">
                    <h2 className="title">Iniciativas</h2>
                    <div className="title-underline"></div>
                </div>

                <div className="section-description" data-aos="fade-up">
                    <p>
                        Diversificamos nuestras iniciativas para impactar en todos los canales y audiencias,
                        logrando experiencias más relevantes y de valor.
                    </p>
                </div>



                {/* Timeline de iniciativas */}
                <div className="row justify-content-center">
                    {iniciativesData.map((item, index) => (
                        <div className="timeline-item m-3" key={index}>
                            <div className="timeline-icon shadow-lg" data-aos="flip-left">
                                <img src={item.image} alt={item.alt} className='img-filter' />
                            </div>
                            <h4 data-aos="fade-up">{item.title}</h4>
                            <div className='line' data-aos="fade-up"></div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Iniciatives;

